import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImage = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 16.0017L16.5879 11.4138C17.3692 10.6327 18.6358 10.6327 19.4171 11.4138L21.0037 13.0004M3.34939 18.6468L7.58116 14.415C8.36248 13.6339 9.62901 13.6339 10.4103 14.415L16.83 20.8347M2.99625 6.99791C2.99625 4.78785 4.78785 2.99625 6.99791 2.99625H17.0021C19.2121 2.99625 21.0037 4.78785 21.0037 6.99791V17.0021C21.0037 19.2121 19.2121 21.0037 17.0021 21.0037H6.99791C4.78785 21.0037 2.99625 19.2121 2.99625 17.0021V6.99791ZM8.99875 7.49812C8.99875 8.32689 8.32689 8.99875 7.49812 8.99875C6.66935 8.99875 5.9975 8.32689 5.9975 7.49812C5.9975 6.66935 6.66935 5.9975 7.49812 5.9975C8.32689 5.9975 8.99875 6.66935 8.99875 7.49812Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgImage);
export default ForwardRef;
